<template lang="pug">
  article.store-wrap
    .store
      a.header(:href="store.url", :title="store.title", :style="`background-image: url(${store.bgimg}`")
        span.wrap
          img.store-logo(:src="store.logo", :alt="store.title")
          span.title {{store.title}}
      .items
        a.item(v-for="(item, index) in store.items", :href="item.url", :title="item.title")
          img(:src="item.image", :alt="item.title")
      a.footer(:href="store.url", :title="store.title") Ver Tienda

</template>
<script>
export default {
  props: {
    store: Object
  }
}
</script>

<style lang="scss" scoped>
  .store-wrap{
    margin: 0 8px;
  }
  .store{
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    background-color: white;
    margin: 2rem 0;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,.1), 0 -1px 2px 0 rgba(0,0,0,.1);
    transition: all .3s ease;
    &:hover{
      box-shadow: 0 7px 16px 0 rgba(0,0,0,.2), 0 1px 3px 0 rgba(0,0,0,.1);
      .footer{
        color: #3483fa;
      }
    }
  }
  .header{
    height: 95px;
    justify-content: center;
    background-position: top center;
    background-size: 140% auto;
    background-repeat: no-repeat;
    display: block;
    margin-bottom: 95px;
    padding: 1px 0;
    .wrap{
      display: block;
      margin-top: 48px;
      .title{
        display: block;
        text-align: center;
        color: #333;
        font-size: 24px;
        margin: 16px 0;
        font-weight: 0;
        font-family: 'Arial', sans-serif;
      }
    }
    .store-logo{
      display: block;
      margin: 0 auto;
      border-radius: 10px;
      width: 80px;
      height: 80px;
      box-shadow: 0 2px 15px 0 rgba(0,0,0,.1);
    }
  }
  .items{
    height: 74px;
    text-align: center;
    .item{
      width: 70px;
      height: 70px;
      border-radius: 8px;
      display: inline-block;
      margin: 3px;
      overflow: hidden;
      border: 1px solid #eee;
    }
  }
  .footer{
    color: #999;
    font-size: 15px;
    font-weight: normal;
    text-decoration: none;
    font-family: 'Arial', sans-serif;
    text-align: center;
    display: block;
    padding: 22px 0;
  }
</style>

